import { useContext, useState } from "react";
import axios from "axios";
import { AuthContext } from "../../Context/AuthContext";

export default function useRespondToConcern() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);

  const { token } = useContext(AuthContext);

  const respond = async (concernId, message) => {
    setLoading(true);
    setError(null);
    setSuccessMessage(null);

    try {
      const response = await axios.patch(
        `${process.env.REACT_APP_SERVER_URL}/raise/concerns/${concernId}/respond`,
        { message },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setSuccessMessage("Response sent successfully!");
      return response.data;
    } catch (err) {
      setError(err.response?.data?.message || "Something went wrong.");
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return { respond, loading, error, successMessage };
}
